import React from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import swal from "sweetalert";
import { getCookie } from "../../inc/cookies";
import config from "../../inc/config";
import { isoToMysqlDateTime } from "../../inc/helper";

import Select from 'react-select';

class AuctionItemEditModule extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,

			auctionItem: {},
      cities: [],
      towns: [],
    };
  }

  componentDidMount() {
		this.getAuctionItem();
    window.scrollTo(0, 0);
  }

  componentWillUnmount() {}

  getAuctionItem() {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    let errorMessages = [];
    let remaining = 2;
    let complete = () => {
      remaining--;
      if (remaining === 0) {
        this.setState({isLoading: false});
        if (errorMessages.length > 0) {
          swal({dangerMode: true, icon: 'warning', title: 'Hay Aksi', text: errorMessages[0], buttons: 'Tamam'}).then(this.props.navigate('/home'));
        }else{
          this.setState({isLoading: false});
        }
      }
    }

    fetch(config.restApi + 'auctionItem/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const auctionItem = responseData.auctionItemInfo;
          this.setState({ auctionItem }, () => {
            if (auctionItem.cityId) {
              this.getTowns(auctionItem.cityId);
            }
          });
        }
        break;
        case 401:  {
          errorMessages.push(responseData.message);
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));

    fetch(config.restApi + 'cities/tr/1', requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          const sortedCities = responseData.cities.sort((first, last) => first.name.localeCompare(last.name));
          this.setState({cities: sortedCities, towns: []});
        }
        break;
        default: {
          errorMessages.push(responseData.message);
        }
        break;
      }
      complete();
    }, () => errorMessages.push('Lütfen internet bağlantınızı kontrol ediniz.'));
  }

  getTowns(cityId) {
    let sessionHash = getCookie('sessionHash');

    const requestOptions = {
      method: 'GET',
      headers: {'Authorization': 'Bearer ' + sessionHash}
    };

    fetch(config.restApi + 'towns/tr/' + cityId, requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({cityId: cityId, townId: '', towns: responseData.towns});
        }
        break;
        case 401:
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          }).then(this.props.navigate('/home'))
        break;
        default: {
          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  saveAuctionItemOnClick = () => {
    let sessionHash = getCookie('sessionHash');

    this.setState({isLoading: true});

  	const startDateIso = new Date(this.state.auctionItem.startDate).toISOString();
    const endDateIso = new Date(this.state.auctionItem.endDate).toISOString();

    const requestOptions = {
      method: 'PUT',
      headers: {'Authorization': 'Bearer ' + sessionHash, 'Content-Type': 'application/json'},
      body: JSON.stringify({cityId: parseInt(this.state.auctionItem.cityId), townId: parseInt(this.state.auctionItem.townId), initialPrice: this.state.auctionItem.initialPrice, thresholdPrice: this.state.auctionItem.thresholdPrice, vat: parseInt(this.state.auctionItem.vat), isSpecialTaxAssessment: parseInt(this.state.auctionItem.isSpecialTaxAssessment), startDate: startDateIso, endDate: endDateIso})
    };

    fetch(config.restApi + 'auctionItem/tr/' + this.props.searchParams.get('id'), requestOptions)
    .then(response => response.json())
    .then(responseData => {
      switch(responseData.status) {
        case 200: {
          this.setState({isLoading: false});
          swal({
            dangerMode: true,
            icon: 'success',
            title: 'Tamamlandı',
            text: 'İhale aracı başarıyla güncellendi.',
            buttons: 'Tamam'
          }).then(() => this.props.navigate(-1));
        }
        break;
        default: {
          this.setState({isLoading: false});

          swal({
            dangerMode: true,
            icon: 'warning',
            title: 'Hay Aksi',
            text: responseData.message,
            buttons: 'Tamam'
          });
        }
        break;
      }
    }, () => swal({dangerMode: true, icon: 'error', title: 'Bağlantı Hatası', text: 'Lütfen internet bağlantınızı kontrol ediniz.', buttons: 'Tamam'}));
  }

  selectedCityOnChange = (selectedCity) => {
    const cityId = selectedCity ? selectedCity.value : '';
    if (cityId) {
      this.getTowns(cityId);
    } else {
      this.setState({auctionItem: {...this.state.auctionItem, cityId: '', townId: ''}, towns: [] });
      return;
    }
  
    this.setState({auctionItem: {...this.state.auctionItem, cityId: cityId, townId: ''}});
  };
  
  selectedTownOnChange = (selectedTown) => {
    const townId = selectedTown ? selectedTown.value : '';
    this.setState({auctionItem: {...this.state.auctionItem, townId: townId}});
  };

  priceFormat = (value) => {
    if (!value) return '';
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  render() {

    const selectedCitiesOptions = [
      {value: '', label: 'Seçiniz' }, ...this.state.cities.map((cityInfo) => ({
        value: cityInfo.id,
        label: `${cityInfo.name}`,
        search: cityInfo.name
      }))
    ];

    const selectedTownsOptions = [
      { value: '', label: 'Seçiniz' }, ...this.state.towns.map((townInfo) => ({
        value: townInfo.id,
        label: `${townInfo.name}`,
        search: townInfo.name
      }))
    ];

    return this.state.isLoading ? (
      <div className="ibox-content sk-loading position-static">
        <div className="sk-spinner sk-spinner-fading-circle">
          <div className="sk-circle1 sk-circle"></div>
          <div className="sk-circle2 sk-circle"></div>
          <div className="sk-circle3 sk-circle"></div>
          <div className="sk-circle4 sk-circle"></div>
          <div className="sk-circle5 sk-circle"></div>
          <div className="sk-circle6 sk-circle"></div>
          <div className="sk-circle7 sk-circle"></div>
          <div className="sk-circle8 sk-circle"></div>
          <div className="sk-circle9 sk-circle"></div>
          <div className="sk-circle10 sk-circle"></div>
          <div className="sk-circle11 sk-circle"></div>
          <div className="sk-circle12 sk-circle"></div>
        </div>
      </div>
    ) : (
      <div className="row custom-container">
        <div className="col">
          <div className="ibox">
            <div className="ibox-title d-flex justify-content-between text-darkblue pr-2">
              <h4 className="text-darkblue">İhale Aracı Düzenle</h4>
              <div className="d-flex">
								<button className="btn bg-orange text-white mr-1" onClick={this.saveAuctionItemOnClick} title="Kaydet"><i className="fa fa-save"></i></button>
								<button className="btn border btn-darkblue text-white" title="Geri" onClick={() => this.props.navigate(-1)}> <i className="fa fa-reply"></i></button>
							</div>
            </div>
            <div className="row">
              <div className="col">
                <div className="ibox">
                  <div className="ibox-content text-darkblue">
                    <div className="row">
                      <div className="col">
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Şehir<strong className="text-danger ml-1">*</strong></strong></h5>
                          <Select
                            className="form-input mb-2 mt-1 text-dark"
                            onChange={this.selectedCityOnChange}
                            options={selectedCitiesOptions}
                            isClearable={true}
                            defaultValue={selectedCitiesOptions.find((city) => city.value === this.state.auctionItem.cityId) || selectedCitiesOptions[0]}
                            placeholder="Seçiniz"
                            value={selectedCitiesOptions.find((city) => city.value === this.state.auctionItem.cityId)}
                            filterOption={(option, searchText) =>
                              option.data.search &&
                              option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                            }
                          />
                        </div>
                        <div className="col-md-6">
                          <h5><strong>İlçe<strong className="text-danger ml-1">*</strong></strong></h5>
                          <Select
                            className="form-input mb-2 mt-1 text-dark"
                            isDisabled={this.state.towns.length === 0}
                            onChange={this.selectedTownOnChange}
                            options={selectedTownsOptions}
                            isClearable={true}
                            defaultValue={selectedTownsOptions.find((town) => town.value === this.state.auctionItem.townId) || selectedTownsOptions[0]}
                            placeholder="Seçiniz"
                            value={selectedTownsOptions.find((town) => town.value === this.state.auctionItem.townId)}
                            filterOption={(option, searchText) =>
                              option.data.search &&
                              option.data.search.toLocaleLowerCase('tr-TR').includes(searchText.toLocaleLowerCase('tr-TR'))
                            }
                          />
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Açılış Fiyatı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({auctionItem: { ...prevState.auctionItem, initialPrice: event.target.value.replace(/[^0-9]/g, "")}}))} onKeyDown={this.handleKeyPress} placeholder="Açılış Fiyatı" type="text" value={this.priceFormat(this.state.auctionItem.initialPrice) || ''} />
                        </div>
                        <div className="col-md-6">
                          <h5><strong>Eşik Fiyatı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-input mb-1" onChange={event => this.setState(prevState => ({auctionItem: { ...prevState.auctionItem, thresholdPrice: event.target.value.replace(/[^0-9]/g, "")}}))} onKeyDown={this.handleKeyPress} placeholder="Açılış Fiyatı" type="text" value={this.priceFormat(this.state.auctionItem.thresholdPrice) || ''} />
                        </div>
                        <div className="col-12">
                          <h5><strong>KDV Oranı<strong className="text-danger ml-1">*</strong></strong></h5>
                          <select className="form-control b-r-sm m-b mr-2" name="KDV Oranı" onChange={event => this.setState(prevState => ({auctionItem: {...prevState.auctionItem, vat: event.target.value}}))} value={this.state.auctionItem.vat >= 0 ? this.state.auctionItem.vat : ''}>
                              <option value="" disabled>KDV Oranı</option>
                                <option value={0}>%0</option>
                                <option value={1}>%1</option>
                                <option value={20}>%20</option>
                            </select>
                        </div>
                        <div className="col-12 mb-2">
                          <input checked={this.state.auctionItem.isSpecialTaxAssessment === 1} id="isSpecialTaxAssessment" onChange={event => this.setState(prevState => ({ auctionItem: { ...prevState.auctionItem, isSpecialTaxAssessment: event.target.checked ? 1 : 0 }}))} type="checkbox" />
                          <label className="form-check-label pl-2" htmlFor="isSpecialTaxAssessment">Özel Matrahlı</label>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-md-6">
                          <h5><strong>Başlangıç Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState(prevState => ({auctionItem: {...prevState.auctionItem, startDate: event.target.value}}))} onKeyDown={this.handleKeyPress} type="datetime-local" value={isoToMysqlDateTime(this.state.auctionItem.startDate) || ''}/>
                        </div>
                        <div className="col-md-6">
                          <h5><strong>Bitiş Tarihi<strong className="text-danger ml-1">*</strong></strong></h5>
                          <input className="form-control form-inputt mb-2 mt-1" onChange={event => this.setState(prevState => ({auctionItem: {...prevState.auctionItem, endDate: event.target.value}}))} onKeyDown={this.handleKeyPress} type="datetime-local" value={isoToMysqlDateTime(this.state.auctionItem.endDate) || ''}/>
                        </div>
                      </div>
                      </div>
                    </div>
                    <div className="text-row text-right mt-2">
                      <button className="btn bg-orange text-white" onClick={this.saveAuctionItemOnClick}><i className="fa fa-save"></i> Kaydet</button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default function AuctionItemEdit(props) {
  return (
    <AuctionItemEditModule navigate={useNavigate()} searchParams={useSearchParams()[0]}></AuctionItemEditModule>
  );
}
